import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { LoadingSpinner } from '../../../components/common/LoadingSpinner';
import { useFeatureFlag } from '../hooks/useFeatureFlag';
import type { FeatureFlagName } from '../types';

interface FlagGateProps {
  flag: FeatureFlagName | string;
  /** When flag is off, redirect to this path. Takes precedence over hide. */
  redirect?: string;
  /** When flag is off, render nothing instead of redirecting. */
  hide?: boolean;
  children: ReactNode;
}

export function FlagGate({ flag, redirect, hide, children }: FlagGateProps) {
  const { enabled, isLoading } = useFeatureFlag(flag);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!enabled) {
    if (redirect) {
      return <Navigate to={redirect} replace />;
    }
    if (hide) {
      return null;
    }
  }

  return <>{children}</>;
}
